import { useQuery } from '@tanstack/react-query'

export interface HomeStats {
  catalogue: {
    productCount: number
    productsWithImages: number
    productsEnriched: number
    enrichmentPercent: number
    outOfStock: number
    brandCount: number
    categoryCount: number
    articleCount: number
  }
  sync: {
    status: 'idle' | 'running' | 'complete' | 'error' | null
    lastSyncAt: number | null
    message: string | null
    progress: number | null
    total: number | null
    error: string | null
  }
  demand: {
    searchesToday: number
    searchesYesterday: number
    searchesWeek: number
    searchesPriorWeek: number
    zeroResultRate7d: number
    zeroResultRatePrior: number
    clickThroughRate7d: number
    clickThroughRatePrior: number
    uniqueSessions7d: number
  }
  attention: {
    zeroResults: Array<{ query: string; count: number; lastSeen: number }>
    strugglingQueries: Array<{
      query: string
      searches: number
      ctr: number
      avgResults: number
    }>
  }
  trending: {
    topQueries: Array<{ query: string; count: number; trend: number | null }>
    topClickedProducts: Array<{
      productId: string
      title: string
      imageUrl: string | null
      brand: string | null
      clicks: number
    }>
  }
  recent: Array<{ query: string; timestamp: number; resultCount: number }>
}

export function useHomeStats() {
  return useQuery({
    queryKey: ['home-stats'],
    queryFn: async (): Promise<HomeStats> => {
      const response = await fetch('/api/stats/home', { credentials: 'include' })
      if (!response.ok) throw new Error('Failed to fetch home stats')
      return response.json()
    },
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  })
}
